import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
//import { newFormatDataBySOV } from "./new-format-data-by-ranking";
//import { formatDataByTonality } from "./format-data-by-tonality";
//import { newFormatDataByTrend } from "./new-format-data-by-trend";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
    useDynamicEntityColors,
} from "../../../constants/app-constant";
import { QUALITATIVE_CHART_TYPE_FILTERS } from "../../../constants/static-filter";
import { TOPICS } from '../../../constants/route-constants';

const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    PROFILING,
    JOURNALIST,
    CITY,
    TOPIC,
} = QUALITATIVE_REPORT_LEVELS;

const {
    SpokespersonEntityTrendCCM,
    SpokespersonEntityTrendIndex,
    SpokespersonEntityTrendNOA,
    SpokespersonEntityTrendReach,
    SpokespersonEntityTrendMAV,
    SpokespersonEntityTrendWordCount,

    SpokespersonJournalistTrendCCM,
    SpokespersonJournalistTrendIndex,
    SpokespersonJournalistTrendNOA,
    SpokespersonJournalistTrendReach,
    SpokespersonJournalistTrendMAV,
    SpokespersonJournalistTrendWordCount,

    SpokespersonProfileTrendCCM,
    SpokespersonProfileTrendIndex,
    SpokespersonProfileTrendNOA,
    SpokespersonProfileTrendReach,
    SpokespersonProfileTrendMAV,
    SpokespersonProfileTrendWordCount,


    SpokespersonTopicTrendCCM,
    SpokespersonTopicTrendIndex,
    SpokespersonTopicTrendNOA,
    SpokespersonTopicTrendReach,
    SpokespersonTopicTrendMAV,
    SpokespersonTopicTrendWordCount,


} = REPORT_TYPES;

const {
    SpokespersonEntityTrendOnline,
    SpokespersonEntityTrendPrint,
    SpokespersonJournalistSOVOnline,
    SpokespersonJournalistSOVPrint,
    SpokespersonJournalistTrendOnline,
    SpokespersonJournalistTrendPrint,
    SpokespersonProfileSOVOnline,
    SpokespersonProfileSOVPrint,
    SpokespersonProfileTrendOnline,
    SpokespersonProfileTrendPrint,
    SpokespersonEntitySOVOnline,
    SpokespersonEntitySOVPrint,
    SpokespersonTopicTrendOnline,
    SpokespersonTopicTrendPrint,
    SpokespersonTopicSOVOnline,
    SpokespersonTopicSOVPrint,
} = GRAPH_DATATYPE;



export const newFormatDataBySpokesperson = (
    d = [],
    graph_type,
    report_type,
    selectedInlineSpokesperson,
    graphDataType,
    selectedInlineEntity,
) => {
    const { online, print } = graphDataType;
    const isEntityLevel =
        online === SpokespersonEntitySOVOnline ||
        print === SpokespersonEntitySOVPrint ||
        online === SpokespersonEntityTrendOnline ||
        print === SpokespersonEntityTrendPrint

    const isJournalistLevel =
        online === SpokespersonJournalistSOVOnline ||
        print === SpokespersonJournalistSOVPrint ||
        online === SpokespersonJournalistTrendOnline ||
        print === SpokespersonJournalistTrendPrint

    const isProfileLevel =
        online === SpokespersonProfileSOVOnline ||
        print === SpokespersonProfileSOVPrint ||
        online === SpokespersonProfileTrendOnline ||
        print === SpokespersonProfileTrendPrint;

    //change as above
    const isTopicLevel = online === SpokespersonTopicSOVOnline ||
        print === SpokespersonTopicSOVPrint ||
        online === SpokespersonTopicTrendOnline ||
        print === SpokespersonTopicTrendPrint;


    const level =
        (isEntityLevel) ? ENTITY :
            (isJournalistLevel) ? JOURNALIST :
                (isTopicLevel) ? TOPIC :
                    (isProfileLevel) ? PROFILING :
                        "No Level";

    const isTrend =
        report_type === SpokespersonEntityTrendCCM ||
        report_type === SpokespersonEntityTrendMAV ||
        report_type === SpokespersonEntityTrendNOA ||
        report_type === SpokespersonEntityTrendIndex ||
        report_type === SpokespersonEntityTrendWordCount ||
        report_type === SpokespersonEntityTrendReach ||
        report_type === SpokespersonJournalistTrendCCM ||
        report_type === SpokespersonJournalistTrendMAV ||
        report_type === SpokespersonJournalistTrendNOA ||
        report_type === SpokespersonJournalistTrendIndex ||
        report_type === SpokespersonJournalistTrendWordCount ||
        report_type === SpokespersonJournalistTrendReach ||
        report_type === SpokespersonProfileTrendCCM ||
        report_type === SpokespersonProfileTrendMAV ||
        report_type === SpokespersonProfileTrendNOA ||
        report_type === SpokespersonProfileTrendIndex ||
        report_type === SpokespersonProfileTrendWordCount ||
        report_type === SpokespersonProfileTrendReach ||
        report_type === SpokespersonTopicTrendCCM ||
        report_type === SpokespersonTopicTrendMAV ||
        report_type === SpokespersonTopicTrendNOA ||
        report_type === SpokespersonTopicTrendIndex ||
        report_type === SpokespersonTopicTrendWordCount ||
        report_type === SpokespersonTopicTrendReach;



    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(d, level, graph_type, measure, selectedInlineEntity.value, selectedInlineSpokesperson?.value);
    }
    else {
        return newFormatDataBySOV(d, level, graph_type, measure, selectedInlineEntity.value, selectedInlineSpokesperson?.value);
    }
};
const newFormatDataBySOV = (d = [], level, graphType, currentMeasure, entity, spokesperson) => {

    const result = d;
    const dataObj = result && result[result.sequence[0]].returnData
    const entities = dataObj.entities;
    const graphData = dataObj.graphdata;
    const datasets = [];
    const labels = [];
    const hcPieChartData = [];
    const lineTension = 0;
    const barThickness = "flex";
    const fill = false;
    const borderWidth = 1;
    if (level === ENTITY) {
        const measure = currentMeasure;
        labels.push("Compnay");
        const entNames = entities && entities.map((ent) => ent.entity_name);
        const spokespersons = dataObj && dataObj.spokespersons.map((j) => j);
        const color = getRandomUniqueColor(spokespersons.length);
        spokespersons && spokespersons.forEach((spokesperson, idx) => {
            const label = spokesperson;
            const backgroundColor = color[idx];
            const borderColor = color[idx];

            const data = [];
            if (graphType === BAR_STACKED_EQUAL_HEIGHT || graphType === BAR_VERTICAL) {
                entities && entities.forEach((ent) => {
                    let currVal = 0;
                    if (graphData.hasOwnProperty(spokesperson) && graphData[spokesperson].hasOwnProperty(ent.entity_name)) {
                        currVal = parseData(graphData[spokesperson][ent.entity_name][measure], true);
                    }
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
            }
        });
        console.log('labels: entNames, datasets, hcPieChartData', entNames, datasets, hcPieChartData)
        return { labels: entNames, datasets, hcPieChartData };
    }
    else if (level === JOURNALIST) {
        const measure = currentMeasure;// currentMeasure === "wordcounttotal" ? "wordcnttotal" : currentMeasure === "index" ? "indexPerc" : currentMeasure;
        labels.push("Journalist");
        const entNames = entities && entities.map((ent) => ent.entity_name);
        const journalists = dataObj && dataObj.journalist.map((j) => j.source_name);
        const color = getRandomUniqueColor(journalists.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(journalists.length / 10);
        if (graphType === BAR_STACKED_EQUAL_HEIGHT || graphType === BAR_VERTICAL) {
            for (let x = 1, y = 0; x <= 1; x++) {
                const set = [];
                journalists && journalists.filter((v, i) => (i >= y && i < (x * 10))).forEach((journalist, idx) => {
                    const label = journalist;
                    const backgroundColor = color[idx];
                    const borderColor = color[idx];

                    const data = [];
                    entities && entities.forEach((ent) => {
                        let currVal = 0;
                        if (graphData.hasOwnProperty(journalist) && graphData[journalist].hasOwnProperty(spokesperson) && graphData[journalist][spokesperson].hasOwnProperty(ent.entity_name)) {
                            currVal = parseData(graphData[journalist][spokesperson][ent.entity_name][measure], true);
                        }
                        data.push(currVal);
                    });
                    set.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
                });
                legendSet.push({ labels: entNames, datasets: set });
                y = x * 10;
            }
            return legendSet;
        }
    }
    else if (level === PROFILING) {
        const measure = currentMeasure;

        const profiles = graphData && Object.keys(graphData);
        const keywordColors = profiles && getRandomUniqueColor(profiles.length);
        const entNames = entities && entities.map((ent) => ent.entity_name);
        if (graphType === BAR_STACKED_EQUAL_HEIGHT || graphType === BAR_VERTICAL) {
            profiles && profiles.forEach((profile, idx) => {
                const label = profile;
                const backgroundColor = keywordColors[idx];
                const borderColor = backgroundColor;
                const data = [];
                entities && entities.forEach((ent, idx) => {
                    let currVal = 0;
                    if (graphData.hasOwnProperty(profile) && graphData[profile].hasOwnProperty(spokesperson) && graphData[profile][spokesperson].hasOwnProperty(ent.entity_name)) {
                        currVal = parseData(graphData[profile][spokesperson][ent.entity_name][measure], true);
                    }
                    data.push(currVal);
                });
                datasets.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
            });
            return { labels: entNames, datasets };
        }
    }
    else if (level === TOPIC) {
        const measure = currentMeasure;
        const entNames = entities && entities.map((ent) => ent.entity_name);
        const topics = dataObj && dataObj.topic.map((j) => j);
        const color = getRandomUniqueColor(topics.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(topics.length / 10);
        for (let x = 1, y = 0; x <= 1; x++) {
            const set = [];
            topics && topics.filter((v, i) => (i >= y && i < (x * 10))).forEach((topic, idx) => {
                const label = topic;
                const backgroundColor = color[idx];
                const borderColor = color[idx];

                const data = [];
                if (graphType === BAR_STACKED_EQUAL_HEIGHT || graphType === BAR_VERTICAL) {
                    entities && entities.forEach((ent) => {
                        let currVal = 0;
                        if (graphData.hasOwnProperty(topic) && graphData[topic].hasOwnProperty(spokesperson) && graphData[topic][spokesperson].hasOwnProperty(ent.entity_name)) {
                            currVal = parseData(graphData[topic][spokesperson][ent.entity_name][measure], true);
                        }
                        data.push(currVal);
                    });
                    set.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
                }
            });
            legendSet.push({ labels: entNames, datasets: set });
            y = x * 10;
        }
        return legendSet;
    }


}
const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, entity, spokesperson) => {
    if (graphType === PIE) {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }
    const result = d;
    const dataObj = result && result[result.sequence[0]].returnData;
    const entities = dataObj.entities;
    const graphData = dataObj.graphdata;
    const journalits = dataObj.journalist;
    const profile = dataObj.profile;
    const topic = dataObj.topic;
    const editions = dataObj && dataObj.states;
    let measure = currentMeasure;
    const color = entities && getRandomUniqueColor(entities.length);
    const datasets = [];
    const labels = graphData && Object.keys(graphData).sort();
    let loopData;
    let loopName;
    if (level === ENTITY) {
        loopData = entities;
        loopName = "entity_name";
    } else if (level === JOURNALIST) {
        loopData = journalits;
        loopName = "source_name";
    } else if (level === PROFILING) {
        loopData = profile;
    } else if (level === TOPIC) {
        loopData = topic;
        loopName = "topic";
    } else if (level === CITY) {
        loopData = editions;
        loopName = "edition";
        //console.log("Add Level HERE");
    }
    else {
        console.log("Add Level HERE");
    }
    // console.log('level', level)
    const legendSet = [];
    const legendSetLength = Math.ceil(loopData.length / 10);
    for (let x = 1, y = 0; x <= 1; x++) {
        const set = [];
        loopData.filter((v, i) => (i >= y && i < (x * 10))).forEach((elm, idx) => {
            const label = (level === TOPIC || level === PROFILING) ? elm : elm[loopName];
            const backgroundColor = color[idx];
            const barThickness = "flex";
            const borderColor = color[idx];
            const borderWidth = 1;
            const data = [];
            const fill = false;
            const lineTension = 1;
            labels.forEach((date) => {

                if (graphData[date].hasOwnProperty(spokesperson)) {
                    const value = graphData[date][spokesperson][label] ? parseData(graphData[date][spokesperson][label][measure], true) : 0

                    const currVal = value;
                    data.push(currVal);
                } else if (graphData[date].hasOwnProperty(label) && graphData[date][label].hasOwnProperty(spokesperson) && graphData[date][label][spokesperson].hasOwnProperty(entity)) {
                    const value = graphData[date][label][spokesperson] ? parseData(graphData[date][label][spokesperson][entity][measure], true) : 0

                    const currVal = value;
                    data.push(currVal);
                }
                else {
                    data.push(0);
                }
            });
            set.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
        });
        legendSet.push({ labels, datasets: set });
        y = x * 10;
    }
    // console.log('labels, datasets', labels, datasets)
    return legendSet;
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
